/*global google*/
import React from 'react'
import PropTypes from 'prop-types'
import AutoComplete from 'material-ui/AutoComplete'

import '../styles.css'

class AddressModule extends React.Component {

  static propTypes = {
    style: PropTypes.shape(),
    placeholder: PropTypes.string,
    addressValue: PropTypes.string,
    onUpdate: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.numberOfLines = 1
    this.state = { dataSource: [], addressValue: props.addressValue }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.addressValue !== nextProps.addressValue){
      this.setState({ addressValue: nextProps.addressValue })
    }
  }


  componentDidMount() {
    this.geocoder = new google.maps.Geocoder()
    this.locationService = new google.maps.places.AutocompleteService()
  }

  componentWillUnmount(){
  }

  update = (key, value) => {
    if (key === 'value'){
      this.setState({ addressValue: value })
      this.props.onUpdate('address', value)
    } else if (key === 'lat'){
      this.props.onUpdate('addressLat', value)
    } else if (key === 'lng'){
      this.props.onUpdate('addressLng', value)
    }
  }

  handleUpdateInput = (input) => {

    this.update('value', input)

    if (!input) {
      this.setState({ dataSource: [] })
      this.update('lat', '')
      this.update('lng', '')
      return
    }

    this.locationService.getPlacePredictions({ input }, (predictions, status) => {
      if (status !== 'OK') {
        console.log('getQueryPredictions was not successful: ' + status)
        this.setState({ dataSource: [] })
      } else {
        this.setState({ dataSource: predictions })
      }
    })
  }

  onNewRequest = (chosenRequest, index) => {
    if (index === -1) {
      return
    }

    const placeId = chosenRequest.place_id
    this.geocoder.geocode( { placeId }, (results, status) => {
      if (status == 'OK') {
        this.update('lat', results[0].geometry.location.lat())
        this.update('lng', results[0].geometry.location.lng())
      } else {
        console.log('Geocoder was not successful: ' + status)
      }
    })
  }

  render() {
    return (
      <div className="vertical-container">
        <div style={{ ...styles.container, ...this.props.style }}>
          <AutoComplete
            style={styles.autoCompleteContainer}
            textFieldStyle={styles.autoCompleteText}
            hintStyle={styles.autoCompleteHint}
            fullWidth={true}
            id='addressTextField'
            hintText={this.props.placeholder}
            filter={AutoComplete.noFilter}
            dataSource={this.state.dataSource}
            dataSourceConfig={dataSourceConfig}
            menuProps={menuProps}
            openOnFocus={true}
            underlineShow={false}
            onUpdateInput={this.handleUpdateInput}
            onNewRequest={this.onNewRequest}
            searchText={this.state.addressValue}/>
        </div>
      </div>
    )
  }
}

const menuProps = { desktop: true }
const dataSourceConfig = { text: 'description', value: 'place_id' }
const styles = {
  container: {
    background: 'white',
    flex: 1,
    height: 16,
    cursor: 'pointer',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center'
  },
  autoCompleteContainer: {
    display: 'flex',
    flex: 1
  },
  autoCompleteText: {
    width: '100%',
    fontSize: 14
  },
  autoCompleteHint: {
    color: '#757575'
  }

}

export default AddressModule



// WEBPACK FOOTER //
// ./src/schedule/common/modules/address/AddressModule.js